<template>
  <div id="guild-detail-page">
    <GuildHeaderDesktop guildName="Clarity" activeMembers="99/100" />
    <v-row>
      <v-col cols="6">
        <v-data-table
          dark
          :headers="headers"
          :items="desserts"
          :items-per-page="20"
          class="elevation-10 ml-4"
        >
          <template #item.name="{ item }">
            <router-link
              class="white--text font-weight-medium"
              :to="{ path: '/character/' + item.name }"
              style="text-decoration: none"
            >{{ item.name }}</router-link>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GuildHeaderDesktop from "@/components/GuildHeaderDesktop.vue";

export default {
  name: "GuildDetailPage",
  components: { GuildHeaderDesktop },
  data() {
    return {
      headers: [
        {
          text: "Family Name",
          align: "start",
          sortable: true,
          value: "name"
        },
        { text: "Gear Score", value: "gearScore" },
        { text: "Last Seen", value: "lastSeen" }
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
          gearScore: 159,
          lastSeen: "online"
        },
        {
          name: "Ice cream sandwich",
          gearScore: 237,
          lastSeen: "online",
          carbs: 37,
          protein: 4.3,
          iron: "1%"
        },
        {
          name: "Eclair",
          gearScore: 262,
          lastSeen: "online",
          carbs: 23,
          protein: 6.0,
          iron: "7%"
        },
        {
          name: "Cupcake",
          gearScore: 305,
          lastSeen: "online",
          carbs: 67,
          protein: 4.3,
          iron: "8%"
        },
        {
          name: "Gingerbread",
          gearScore: 356,
          lastSeen: "online",
          carbs: 49,
          protein: 3.9,
          iron: "16%"
        },
        {
          name: "Jelly bean",
          gearScore: 375,
          lastSeen: "online",
          carbs: 94,
          protein: 0.0,
          iron: "0%"
        },
        {
          name: "Lollipop",
          gearScore: 392,
          lastSeen: "online",
          carbs: 98,
          protein: 0,
          iron: "2%"
        },
        {
          name: "Honeycomb",
          gearScore: 408,
          lastSeen: "online",
          carbs: 87,
          protein: 6.5,
          iron: "45%"
        },
        {
          name: "Donut",
          gearScore: 452,
          lastSeen: "online",
          carbs: 51,
          protein: 4.9,
          iron: "22%"
        },
        {
          name: "KitKat",
          gearScore: 518,
          lastSeen: "online",
          carbs: 65,
          protein: 7,
          iron: "6%"
        }
      ]
    };
  }
};
</script>

<style scoped>
</style>